export default "__VITE_ASSET__2sUlfV3___"